import { render, staticRenderFns } from "./EstoqueTabs.vue?vue&type=template&id=3a743c99&scoped=true"
import script from "./EstoqueTabs.vue?vue&type=script&lang=js"
export * from "./EstoqueTabs.vue?vue&type=script&lang=js"
import style0 from "./EstoqueTabs.vue?vue&type=style&index=0&id=3a743c99&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3a743c99",
  null
  
)

export default component.exports